import dynamic from 'next/dynamic';

import View360Icon from '@/icons/duotone/view-360.svg';
import { FeaturedText } from '@/molecules';

import { generatedListingConfig } from '@/lib/contexts/listing-config.generated';

import type { FunctionComponent } from 'react';
import type { TypeView360Props } from './types';

const ModalView360 = dynamic(() => import('@/molecules/modal-view360'), {
  ssr: true,
});

// Only the HoM vivienda ("hero") opts into the accent band that matches the
// mortgage CTA. bg-accent falls back to bgcolor when the tenant has no
// accentbg, so on legacy tenants with a dark bgcolor the block went black.
const useAccentBackground = generatedListingConfig.viviendaPageStyle === 'hero';

export const View360: FunctionComponent<TypeView360Props> = ({
  className = '',
  src,
  flat,
}: TypeView360Props) => (
  <FeaturedText
    Icon={View360Icon}
    text="Explora tu nueva casa en una vista 360º"
    className={className}
    {...(useAccentBackground ? { background: 'bg-accent' } : {})}
  >
    <ModalView360 type="button" src={src} flat={flat} />
  </FeaturedText>
);

View360.displayName = 'View360';
